import React from "react";
import { Route } from "react-router-dom";
import PrivateRoute from "src/routes/PrivateRoute";
import { KeywordsPage } from "../pages";

export const routes = (
  <Route
    path="/keywords"
    element={
      <PrivateRoute>
        <KeywordsPage />
      </PrivateRoute>
    }
  />
);
